import { Injectable } from "@angular/core";
import brandInfo from "../../environments/brand.json";
import { PrismicService } from "./prismic.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class GoogleMapsService {

  constructor(private prismicService: PrismicService) {}

  private appendGoogleMapsScript(googleMapsKey: string, language: string): void {
    const googleMaps = document.createElement("script");
    googleMaps.setAttribute("async", "true");
    googleMaps.setAttribute("type", "text/javascript");
    const languageCode = String(language || "").split("-")[0] || "en";
    const googleMapsUrl = new URL("https://maps.googleapis.com/maps/api/js");
    googleMapsUrl.search = new URLSearchParams({
      key: googleMapsKey,
      libraries: "places",
      language: languageCode,
      loading: "async",
    }).toString();
    googleMaps.setAttribute("src", googleMapsUrl.toString());
    document.documentElement.firstChild.appendChild(googleMaps);
  }

  loadScriptTag(): void {

    const prismicEnv = this.prismicService.getEnvironment("prod");
    const language = sessionStorage.getItem("preferredLanguage")
      ? sessionStorage.getItem("preferredLanguage")
      : brandInfo.language;

    const googleMapsKey = this.prismicService.getValidatedGoogleMapsKey(prismicEnv);
    if (googleMapsKey) {
      this.appendGoogleMapsScript(googleMapsKey, language);
      return;
    }

    // Fallback for first-load race when env has not been cached yet.
    this.prismicService.fetchEnvironment("prod")
      .then((fetchedEnv) => {
        const fetchedKey = this.prismicService.getValidatedGoogleMapsKey(fetchedEnv);
        if (!fetchedKey) {
          return;
        }
        this.appendGoogleMapsScript(fetchedKey, language);
      })
      .catch(() => {
        // No-op: existing UI flow handles unavailable maps gracefully.
      });
  }
}
